/** Routes du module — propriétaire : Agent A2 — Mes conditions commerciales (portail). */
import type { RouteObject } from 'react-router';
import { Handshake } from 'lucide-react';
import type { EntreeNav } from '../../../app/navigation';
import { RequirePermission } from '../../../shared/auth/session';
import { MesConditions } from './MesConditions';

export const routesProConditions: RouteObject[] = [
  { path: 'conditions', element: <RequirePermission permission="accord.lire.propres"><MesConditions /></RequirePermission> },
];
export const navProConditions: EntreeNav[] = [
  { libelle: 'Mes conditions', vers: '/pro/conditions', permission: 'accord.lire.propres', icone: Handshake },
];
